var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWeight = function SvgWeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#691B33",
    d: "M17.502 0H.514A.514.514 0 0 0 0 .514v16.972A.514.514 0 0 0 .514 18h16.988a.514.514 0 0 0 .513-.514V.498A.514.514 0 0 0 17.502 0Zm-.514 16.988H1.012V.997h15.991l-.015 15.99Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#691B33",
    d: "M6.259 9.99h5.498a3.751 3.751 0 0 0 3.746-3.747V2.996a.514.514 0 0 0-.514-.514H3.01a.514.514 0 0 0-.514.514v3.247A3.75 3.75 0 0 0 6.26 9.99ZM3.515 3.5h1.027v.996a.514.514 0 1 0 .997 0V3.5h.997v.997a.514.514 0 0 0 1.002 0V3.5h.956v.997a.514.514 0 0 0 1.002 0V3.5h.997v.997a.514.514 0 0 0 1.002 0V3.5h.997v.997a.514.514 0 1 0 1.027 0V3.5h.992v2.744a2.749 2.749 0 0 1-2.754 2.75H9.522V6.494a.514.514 0 0 0-.997 0v2.497H6.259a2.749 2.749 0 0 1-2.744-2.749V3.5Z"
  })));
};
export default SvgWeight;